
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Image } from '@ta-interaktiv/contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h4>Schwerer Übergriff in Baubaracke</h4>
    <p>
  Selina, acht Jahre alt, spielt im Garten des Elternhauses in Starrkirch-Wil SO. Sie springt auf dem Trampolin, als
  sich William W. nähert. «Du chasch aber guet gumpe», sagt er. Dann lockt er das Mädchen zu einer Baubaracke, keine 200
  Meter entfernt. Dort könnten sie gemeinsam Musik hören, schlägt der damals 33-Jährige vor.
    </p>
    <Image file={require('images/trampolin.jpg')} source='Selina auf dem Trampolin, von welchem sie W. weglockte (Privatarchiv).' mdxType="Image" />
    <p>
  Im Container fällt er über die Primarschülerin her, missbraucht sie schwer, während mehreren Stunden. Der Täter hört
  selbst dann nicht auf, als sein Opfer über Schmerzen klagt. Er habe gelächelt, gibt die Geschädigte später an. Und ihr
  am Schluss gedroht: Niemandem dürfe Selina etwas sagen. Trotzdem kann die Polizei ihn noch am selben Augusttag
  verhaften.
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;